export const PHONE_MASK = '99 999 99 99 999';
